<template>
  <div class="columns">    
    <div class="column is-four-fifths">
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th style="width: 150px"></th>
            <th>Model</th>
            <th style="width: 200px">Asset ID</th>
            <th style="width: 250px">Serials</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Antenna</td>
            <td v-if="!editing">{{ getComponentModelFromShortcode(terminal?.hardware?.antenna?.model) || '-' }}</td>
            <td v-else> 
              <b-select placeholder="Select an Antenna" v-model="terminalHardware.antenna.model" expanded>
                <option :value="null">Select an Antenna</option>
                <option 
                  v-for="option in getModelsForHardwareType('DEV_ANTNA')"
                  :value="option.shortcode"
                  :key="option.shortcode">
                  {{ option.name }}
                </option>
              </b-select>
            </td>
            <td>{{ terminal?.hardware?.antenna?.assetId || '-' }}</td>
            <td>{{ terminal?.hardware?.antenna?.serial || '-' }}</td>
          </tr>
          <tr>
            <td>Terminal</td>
            <td v-if="!editing">{{ getComponentModelFromShortcode(terminal?.hardware?.terminal?.model) }}</td>
            <td v-else>
              <b-select placeholder="Select a Terminal" v-model="terminalHardware.terminal.model" expanded >
                <option :value="null">Select a Terminal</option>
                <option
                  v-for="option in getModelsForHardwareType('DEV_TRMNL')"
                  :value="option.shortcode"
                  :key="option.shortcode">
                  {{ option.name }}
                </option>
              </b-select>
            </td>
            <td>{{ terminal?.hardware?.terminal?.assetId || '-' }}</td>
            <td>{{ terminal?.hardware?.terminal?.serial || '-' }}</td>
          </tr>
          <template v-if="terminal?.hardware?.leoModem?.serial">
            <tr>
              <td>LEO Modem</td>
              <td>{{ getComponentModelFromShortcode(terminal?.hardware?.leoModem?.model) }}</td>
              <td>{{ terminal?.hardware?.leoModem?.assetId || '-' }}</td>
              <td><span class="has-text-weight-semibold">SN:</span> {{ terminal?.hardware?.leoModem?.serial || '-' }}<br />
              <span class="has-text-weight-semibold">IMEI:</span> {{ terminal?.hardware?.leoModem?.imei || '-' }}<br />
              <span class="has-text-weight-semibold">IMSI:</span> {{ terminal?.hardware?.leoModem?.imsi || '-' }}</td>
            </tr>
            <tr>
              <td>KRCM</td>
              <td>-</td>
              <td>{{ terminal?.hardware?.krcm?.assetId || '-' }}</td>
              <td>{{ terminal?.hardware?.krcm?.serial || '-' }}</td>
            </tr>
            <tr>
              <td>MCRCM</td>
              <td>-</td>
              <td>{{ terminal?.hardware?.mrcrm?.assetId || '-' }}</td>
              <td>{{ terminal?.hardware?.mrcrm?.serial || '-' }}</td>
            </tr>
            <tr>
              <td>EGR</td>
              <td>-</td>
              <td>{{ terminal?.hardware?.egr?.assetId || '-' }}</td>
              <td>{{ terminal?.hardware?.egr?.serial || '-' }}</td>
            </tr>
            <tr>
              <td>OIM</td>
              <td>-</td>
              <td>{{ terminal?.hardware?.oim?.assetId || '-' }}</td>
              <td>{{ terminal?.hardware?.oim?.serial || '-' }}</td>
            </tr>
            <tr>
              <td>Cartridge</td>
              <td>-</td>
              <td>{{ terminal?.hardware?.cartridge?.assetId || '-' }}</td>
              <td>{{ terminal?.hardware?.cartridge?.serial || '-' }}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td>GEO Modem</td>
              <td  v-if="!editing">{{ getComponentModelFromShortcode(terminal?.hardware?.geoModem?.model) }}</td>
              <td v-else>
                <b-select placeholder="Select a GEO Modem" v-model="terminalHardware.geoModem.model" expanded >
                  <option :value="null">Select a GEO Modem</option>
                  <option
                    v-for="option in getModelsForHardwareType('DEV_MODEM')"
                    :value="option.shortcode"
                    :key="option.shortcode">
                    {{ option.name }}
                  </option>
                </b-select>
              </td>
              <td>{{ terminal?.hardware?.geoModem?.assetId || '-' }}</td>
              <td>{{ terminal?.hardware?.geoModem?.serial || '-' }}</td>
            </tr>
            <tr>
              <td>BUC</td>
              <td v-if="!editing">{{ getComponentModelFromShortcode(terminal?.hardware?.buc?.model) }}</td>
              <td v-else>
                <b-select placeholder="Select a BUC" v-model="terminalHardware.buc.model" expanded >
                  <option :value="null">Select a BUC</option>
                  <option
                    v-for="option in getModelsForHardwareType('DEV_BUC')"
                    :value="option.shortcode"
                    :key="option.shortcode">
                    {{ option.name }}
                  </option>
                </b-select>
              </td>
              <td>{{ terminal?.hardware?.buc?.assetId || '-' }}</td>
              <td>{{ terminal?.hardware?.buc?.serial || '-' }}</td>
            </tr>
            <tr>
              <td>LNB</td>
              <td v-if="!editing">{{ getComponentModelFromShortcode(terminal?.hardware?.lnb?.model) }}</td>
              <td v-else>
                <b-select placeholder="Select a LNB" v-model="terminalHardware.lnb.model" expanded >
                  <option :value="null">Select a LNB</option>
                  <option
                    v-for="option in getModelsForHardwareType('DEV_LNB')"
                    :value="option.shortcode"
                    :key="option.shortcode">
                    {{ option.name }}
                  </option>
                </b-select>
              </td>
              <td>{{ terminal?.hardware?.lnb?.assetId || '-' }}</td>
              <td>{{ terminal?.hardware?.lnb?.serial || '-' }}</td>
            </tr>
            <tr>
              <td>Diplexer</td>
              <td>{{ getComponentModelFromShortcode(terminal?.hardware?.diplexer?.model) }}</td>
              <td>{{ terminal?.hardware?.diplexer?.assetId || '-' }}</td>
              <td>{{ terminal?.hardware?.diplexer?.serial || '-' }}</td>
            </tr>
            <tr>
              <td>Hybrid Router</td>
              <td v-if="!editing">{{ getComponentModelFromShortcode(terminal?.hardware?.hybridRouter?.model) }}</td>
              <td v-else>
                <b-select placeholder="Select a Hybrid Router" v-model="terminalHardware.hybridRouter.model" expanded >
                  <option :value="null">Select a Hybrid Router</option>
                  <option
                    v-for="option in getModelsForHardwareType('DEV_CLRTR')"
                    :value="option.shortcode"
                    :key="option.shortcode">
                    {{ option.name }}
                  </option>
                </b-select>
              </td>
              <td>{{ terminal?.hardware?.hybridRouter?.assetId || '-' }}</td>
              <td><span class="has-text-weight-semibold">SN:</span> {{ terminal?.hardware?.hybridRouter?.serial || '-' }}<br />
                <span class="has-text-weight-semibold">IMEI:</span> {{ terminal?.hardware?.hybridRouter?.imei }}<br />
                <span class="has-text-weight-semibold">ICCID:</span> {{ terminal?.hardware?.hybridRouter?.iccid }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div class="column is-one-fifths">
      <div class="px-4 action-links-container">
        <p v-if="!editing">
          <a v-if="isHardwareConfigurable && $hasRole('Super User,Kymeta Admin,Product Support')" @click="configureHardware">Configure</a>
          <span v-else class="has-text-grey" title="Hardware model configuration is not allowed for U8 terminal.">Configure</span>
        </p>
        <div v-else>
          <p><a @click="cancelConfigure">Cancel</a></p>
          <p class="mt-2">
            <a @click="saveHardwareEdited">Save</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, ref, getCurrentInstance } from 'vue';
import { useTerminalsStore } from '../terminals-store';
import getComponentModelFromShortcode from '../../utilities/getComponentModelFromShortcode';
import getModelsForHardwareType from '../../utilities/geModelsForHardwareType';

const editing = ref(false);
const app = getCurrentInstance();
const store = useTerminalsStore();
const terminal = computed(() => store.state.terminal);
const terminalHardware = computed(() => {
  // assign default values so the view model has some initial context
  const defaultHw = {
    antenna: { serial: null, assetId: null },
    geoModem: { serial: null, assetId: null },
    buc: { serial: null, assetId: null },
    lnb: { serial: null, assetId: null },
    hybridRouter: { serial: null, assetId: null },
    terminal: { serial: null, assetId: null },
  }
  // fill with defaults and override with the vuex values
  return { ...defaultHw, ...terminal?.value?.hardware };
});
const originalHardware = ref(terminalHardware.value);
const isHardwareConfigurable = computed(() => {
  const productCode = terminal?.value?.productCode?.substr(0, 2) ?? '';
  const productName = terminal?.value?.productName ?? '';
  return productCode.toLowerCase() != 'u8' || productName.toLowerCase().includes('ug'); // is configurable if the Product is not a U8 or if the Product is an upgrade "UG"
});

const configureHardware = async () => {
  // stash unmodified hardware values
  originalHardware.value = JSON.parse(JSON.stringify(terminal?.value?.hardware));
  editing.value = true;
}

const cancelConfigure = () => {
  // restore unmodified hardware values
  terminal.value.hardware = originalHardware.value;
  editing.value = false;
}

const saveHardwareEdited = async () => {
  if (!isHardwareConfigurable.value) {
    editing.value = false;
    app.proxy.$buefy.toast.open({
      duration: 5000,
      type: 'is-danger',
      message: 'Can not modify U8 hardware models.'
    });
    return null;
  }
  const componentHardwareModel = terminalHardware?.value;
  // all fields blank we will allow to save, regardless of any DHCP calculated values. [ALL FIELDS BLANK]
  if (!componentHardwareModel?.antenna?.model && !componentHardwareModel?.geoModem?.model && !componentHardwareModel?.buc?.model && !componentHardwareModel?.lnb?.model && !componentHardwareModel?.terminal?.model && !componentHardwareModel?.hybridRouter?.model) {
    // if all fields blank, do nothing and continue to save
    // TODO: huh?
  } else {
    // assign the TerminalId for proper context
    const saveResult = await store.dispatch('updateHardwareModels', componentHardwareModel);
    // catch any errors
    if (!saveResult.isSuccess) {
      app.proxy.$buefy.toast.open({
        duration: 5000,
        type: 'is-danger',
        message: `Unable to save. Error: ${saveResult?.data}`
      });
      return null;
    }

    editing.value = false;
    // KyAnalytics client plugin, event tracker
    app.proxy.$kya.event('remotes', 'saveTerminalHardwareEdit', 'Save hardware configure clicked.', { terminalId: terminal.value.id });
    return true;
  }
  return null;
}
</script>
